import { render, staticRenderFns } from "./GoodsTypeModal.vue?vue&type=template&id=09a09856&"
import script from "./GoodsTypeModal.vue?vue&type=script&lang=js&"
export * from "./GoodsTypeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports